module.exports = __webpack_public_path__ + "img/151.5f3e91d1.jpg";